import { render } from "./ListingGeneric.vue?vue&type=template&id=259bda69"
import script from "./ListingGeneric.vue?vue&type=script&lang=js"
export * from "./ListingGeneric.vue?vue&type=script&lang=js"
script.render = render

export default script